import { FootnoteDefinition, LabelStyle } from '../services/layout';
import { makeStyles, Theme, createStyles, FormHelperText, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { FieldLabel } from './FieldLabel';
import { Footnote } from './Footnote';

export interface FormControlProps {
  label?: string;
  helpText?: string;
  footnote?: FootnoteDefinition;
  style?: {
      label?: LabelStyle;
  };
  error?: string;
}

const useStyles = makeStyles(function(theme: Theme) {
  return createStyles({
    root: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(0, 1),
      margin: theme.spacing(1, 0, 2, 0),
      position: 'relative',
      maxWidth: '100%'
    },
    text: {
      flex: 1,
      padding: 0,
      margin: 0
    },
    label: {
      marginLeft: -theme.spacing(1),
      flex: 1
    },
    helperText: {
      marginLeft: theme.spacing(3),
      marginTop: theme.spacing(1)
    },
    errorContainer: {},
    error: {
      display: 'block',
      color: theme.palette.error.main,
      marginLeft: theme.spacing(3)
    }
  })
});

export const FormControl: FC<FormControlProps> = function(props) {
  const classes = useStyles(props);
  return (
    <div className = { classes.root }>
      <FieldLabel className = { classes.label } labelStyle = { props.style && props.style.label }>
        { props.label }
      </FieldLabel>
      { props.children }
      { props.helpText &&
        <FormHelperText className = { classes.helperText }>
          { props.helpText }
        </FormHelperText>
      }
      { props.error &&
        <div className = { classes.errorContainer }>
          {
            props.error.split('\n').map((e, r) =>
              <Typography
                key = { r }
                className = { classes.error }
                variant = { 'caption' }>
              { e }
              </Typography>
            )
          }
        </div>
      }
      {/* unnecessary div */}
      <div>
        { props.footnote &&
          <Footnote { ...props.footnote }></Footnote>
        }
      </div>
    </div>
  )
};
